export default function FileDownloadIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path
        d="M9.00009 11.9463L5.03484 7.98103L6.23278 6.75459L8.14697 8.67309V2.84766H9.85322V8.67309L11.7674 6.75459L12.9653 7.98103L9.00009 11.9463ZM4.55391 15.1525C4.08166 15.1525 3.67922 14.9862 3.34659 14.6536C3.01397 14.321 2.84766 13.9185 2.84766 13.4463V11.1963H4.55391V13.4463H13.4463V11.1963H15.1525V13.4463C15.1525 13.9185 14.9862 14.321 14.6536 14.6536C14.321 14.9862 13.9185 15.1525 13.4463 15.1525H4.55391Z"
        fill="white"
      />
    </svg>
  );
}
